import Button from '@Components/Buttons/Button'
import Popup from '@Components/Popups/Popup'
import React from 'react'
import bulkErrorStrings from '@Components/Popups/BulkUploadErrorPopup/bulk-error-strings'
import { BulkUploadErrorType } from '@App/enum/bulk-upload-error-type'
import { Maybe } from '@Types'
import './index.scss'

interface BulkUploadErrorPopupProps {
    modalErrorType: BulkUploadErrorType
    modalErrorMessage: Maybe<string>
    onClose: () => void
}

const BulkUploadErrorPopup = (props: BulkUploadErrorPopupProps) => {
    const errorText = bulkErrorStrings[props.modalErrorType]
    const errorBody = props.modalErrorMessage ?? errorText.errorBody
    return (
        <Popup onClose={props.onClose} showClose={false}>
            <div className="documents-container">
                <div className="info-head">
                    <h3>{errorText.header}</h3>
                    <p className="bold">{errorText.subheader}</p>
                    {errorBody && <p>{errorBody}</p>}
                    <p>{errorText.footer}</p>
                </div>
                <div className="search-confirm-popup-content">
                    <div className="buttons-block">
                        <Button mainColor type="primary" onClick={props.onClose}>
                            OK
                        </Button>
                    </div>
                </div>
            </div>
        </Popup>
    )
}

export default BulkUploadErrorPopup
